import Vue from "vue";
import VueRouter from "vue-router";
import HomeView from "../views/HomeView.vue";
import PlayView from "../views/PlayView.vue";

Vue.use(VueRouter);

const OPENING_DATE = new Date("2026-07-15T00:00:00");

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/home",
    name: "homeAlways",
    component: HomeView,
  },
  {
    path: "/accueil",
    name: "accueil",
    component: HomeView,
  },
  {
    path: "/jouer",
    name: "jouer",
    component: PlayView,
  },
  {
    path: "/status/:_id/:_secu",
    name: "status",
    component: () => import("../views/StatusView.vue"),
  },
  {
    path: "/contact",
    name: "contact",
    component: () => import("../views/ContactView.vue"),
  },
  {
    path: "/formulaire",
    name: "form",
    component: () => import("../views/FormView.vue"),
  },
  {
    path: "/attendre",
    name: "wait",
    component: () => import("../views/WaitView.vue"),
  },
  {
    path: "/mentions",
    name: "mentions",
    component: () => import("../views/MentionsView.vue"),
  },
  {
    path: "/merci",
    name: "merci",
    component: () => import("../views/MerciView.vue"),
  },
  {
    path: "/fini",
    name: "done",
    component: () => import("../views/DoneView.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    name: "notFound",
    component: () => import("../views/NotFound.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  const isBeforeOpening = new Date() < OPENING_DATE;
  if (isBeforeOpening && to.name === "home") {
    next({ name: "wait" });
  } else {
    next();
  }
});

export default router;
